import styled, { css } from "styled-components"

export const Container = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  z-index: 2;
  visibility: hidden;

  svg {
    width: 35px;
    height: 35px;
    margin: auto;
    fill: #707070;
  }

  ${props =>
    props.active
      ? css`
          visibility: visible;
        `
      : ""}

  &:hover,
  &:focus {
    -webkit-transition: opacity 100ms ease-in;
    -o-transition: opacity 100ms ease-in;
    -moz-transition: opacity 100ms ease-in;
    transition: opacity 100ms ease-in;
    svg {
      fill: #3d3d3d;
    }
  }

  @media (max-width: 768px) {
    right: 5px;
    bottom: 50px;
  }
`
